import dayjs from 'dayjs';
import { useRouter } from 'next/router';
import { SITE_LIVINGSOCIAL } from '../config/setup/setup';
import { getIsOpen } from './deals';
import { replaceImageServer } from './image';
import { makeUrlAbsolute } from './url';

export function getSnippetAvailability(deal) {
  const isOpen = getIsOpen(deal);
  let totalProducts = 0;
  const getAvailableProducts = deal.products?.filter((product) => {
    totalProducts +=
      product.dailyPurchaseCapReached || product.weeklyPurchaseCapReached
        ? 0
        : product.totalRemaining;

    return totalProducts;
  });

  if (
    !isOpen ||
    (deal.totalRemaining <= 0 && totalProducts === 0) ||
    deal.soldOut
  ) {
    return 'OutOfStock';
  } else {
    return 'InStock';
  }
}

const createGshopHeadline = ({ title, extraData }) => {
  return `${title.replace('44 Locations Nationwide', extraData)}`;
};

export const parseRichSnippets = (deal, productId, pdtUrl, productDetails) => {
  const noShowCats = [83]; // not generated for adult category
  const router = useRouter();
  let isGoogleShopURL = false;
  if (typeof router?.query?.slug === 'object') {
    isGoogleShopURL = Boolean(
      router?.query?.slug?.find((element) => element === 'gshop'),
    );
  }

  const isLivingSocialUK = process.env.NEXT_PUBLIC_SITE === SITE_LIVINGSOCIAL;
  const isGShopOverride =
    deal?.id === 28_376_947 && isLivingSocialUK && isGoogleShopURL;
  let headline = null;
  if (isGShopOverride) {
    headline = createGshopHeadline({
      extraData: router?.query?.slug[router?.query?.slug?.length - 1],
      title: deal?.headline,
    });
  }

  if (!deal || (deal.category && noShowCats.includes(deal.category.id))) {
    return null;
  }
  const data = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    image: [
      productId && productDetails?.images?.[0]
        ? replaceImageServer({
            dealId: deal?.id,
            image: productDetails.images[0],
          })
        : replaceImageServer({
            dealId: deal?.id,
            image: deal.images ? deal.images[0] : null,
          }),
    ],
    name: productId
      ? productDetails?.friendlyName
      : isGShopOverride
      ? headline
      : deal.headline || '',
    offers: {
      '@type': 'Offer',
      availability: productId
        ? productDetails?.soldOut
          ? 'OutOfStock'
          : 'InStock'
        : getSnippetAvailability(deal),
      itemOffered: productId
        ? productDetails?.friendlyName
        : isGShopOverride
        ? headline
        : deal.headline || '',
      price: productId ? productDetails?.price : deal.price,
      priceCurrency: deal.currency,
      priceValidUntil: dayjs(deal.closingDate).endOf('day').toISOString(),
      url: productId ? pdtUrl : makeUrlAbsolute(deal.urlPath),
    },
  };
  if (!productId) {
    data.description = deal?.title;
  }
  // review...
  if (deal.reviewSummary && deal.reviewSummary.total === 1) {
    const review = deal.reviews[0];
    data.review = {
      author: {
        '@type': 'Person',
        name: review.nameLocation,
      },
      reviewRating: {
        ratingValue: review.rating,
      },
    };
  }

  // ...or aggragate review
  if (deal.reviewSummary && deal.reviewSummary.total > 1) {
    data.aggregateRating = {
      ratingCount: deal.reviewSummary.total,
      ratingValue: deal.reviewSummary.average,
    };
  }

  return JSON.stringify(data);
};
